import { render, staticRenderFns } from "./CookieBadge.vue?vue&type=template&id=e7f40e96&scoped=true&"
import script from "./CookieBadge.vue?vue&type=script&lang=js&"
export * from "./CookieBadge.vue?vue&type=script&lang=js&"
import style0 from "./CookieBadge.vue?vue&type=style&index=0&id=e7f40e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f40e96",
  null
  
)

export default component.exports